import { Table, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Gacha } from '@/api-client/generated/models';
import { ROUTES } from '@/constants';
import { createApiClientWithToken } from '@/service/PreRegistrationApiFactory';

const columns: ColumnsType = [
  {
    title: 'ガチャ名',
    dataIndex: 'name',
    key: 'name',
    render: (_: string, gacha: Gacha) => <Link to={{ pathname: `/gacha/${gacha.id}` }}>{gacha.name}</Link>,
  },
];

const ListGacha: React.FC<{}> = () => {
  const [gachas, setGachas] = useState([] as Gacha[]);

  useEffect(() => {
    const api = createApiClientWithToken();
    api.listGacha().then((gachasResponse) => {
      setGachas(gachasResponse);
    });
  }, []);

  if (!gachas) {
    return <div>Loading</div>;
  }

  return (
    <div>
      <Typography.Title>ガチャ一覧</Typography.Title>
      <Link to={ROUTES.topGachaCreate}>新しいガチャを作成する</Link>
      <Table columns={columns} dataSource={gachas} rowKey={(gacha: Gacha) => gacha.name} />
    </div>
  );
};

export default ListGacha;
